// extracted by mini-css-extract-plugin
module.exports = {"container":"Carousel_container__X5bwo","viewport":"Carousel_viewport__s30nF","list":"Carousel_list___UzPx"};